export const LIKE='LIKE'
export const FETCH_ALL='FETCH_ALL'
export const UPDATE='UPDATE'
export const DELETE='DELETE'
export const CREATE="CREATE"